export default __webpack_public_path__ + "static/media/addMerchandise.6cd48449.png";